import { DeleteOutlined, EditOutlined, CopyOutlined } from "@ant-design/icons";
import { Badge, Button, Popconfirm } from "antd";
import { Locale } from "../../utils";

const i18n = Locale.getInstance();

export const customPageListColumns = (
  deleteMutation,
  duplicateMutation,
  publishMutation,
  token,
  setLoading,
  router
) => {
  return [
    {
      title: "ID",
      dataIndex: "id",
      width: 60,
    },
    {
      title: i18n.t("customPage.pageType"),
      dataIndex: "page_type",
      width: 120,
      render: (text) => {
        const typeMap = {
          home: i18n.t("customPage.pageTypeHome"),
          user: i18n.t("customPage.pageTypeUser"),
          "video-list": i18n.t("customPage.pageTypeVideoList"),
        };
        return typeMap[text] || text;
      },
    },
    {
      title: i18n.t("customPage.language"),
      dataIndex: "language",
      width: 80,
      render: (text) => {
        return text === "ug" ? i18n.t("customPage.languageUyghur") : i18n.t("customPage.languageChinese");
      },
    },
    {
      title: i18n.t("common.statusLabel"),
      dataIndex: "status",
      width: 100,
      render: (status) => {
        return (
          <Badge
            status={status === "published" ? "success" : "default"}
            text={status === "published" ? i18n.t("customPage.statusPublished") : i18n.t("customPage.statusDraft")}
          />
        );
      },
    },
    {
      title: i18n.t("customPage.version"),
      dataIndex: "version",
      width: 80,
    },
    {
      title: i18n.t("customPage.publishedAt"),
      dataIndex: "published_at",
      width: 150,
      render: (text) => text || "-",
    },
    {
      title: i18n.t("users.date"),
      dataIndex: "created_at",
      width: 150,
    },
    {
      title: i18n.t("users.actions"),
      width: 300,
      render: (item) => {
        return (
          <>
            <Button
              type="link"
              size="small"
              icon={<EditOutlined />}
              onClick={() => {
                router.push({
                  pathname: `/main/custom-pages/edit/${item.id}`,
                });
              }}
            >
              {i18n.t("product.productItem.actionEdit")}
            </Button>
            <Button
              type="link"
              size="small"
              icon={<CopyOutlined />}
              onClick={() => {
                setLoading(true);
                duplicateMutation.mutate({ id: item.id, token });
              }}
            >
              {i18n.t("customPage.duplicate")}
            </Button>
            {item.status === "draft" && (
              <Button
                type="link"
                size="small"
                onClick={() => {
                  setLoading(true);
                  publishMutation.mutate({ id: item.id, token });
                }}
              >
                {i18n.t("customPage.publish")}
              </Button>
            )}
            <Popconfirm
              title={i18n.t("sales.deleteWarning")}
              onConfirm={() => {
                setLoading(true);
                deleteMutation.mutate({
                  resource: "custom-pages",
                  params: {
                    id: item.id,
                    token,
                  },
                });
              }}
              okText={i18n.t("base.modal.okText")}
              cancelText={i18n.t("base.modal.cancelText")}
            >
              <Button danger type="link" size="small" icon={<DeleteOutlined />}>
                {i18n.t("common.delete")}
              </Button>
            </Popconfirm>
          </>
        );
      },
    },
  ];
};


